module.exports = __webpack_public_path__ + "static/media/featuresbanner.e02db86f.png";